// extracted by mini-css-extract-plugin
export default {"cls1":"_4ELBWVKbV_FcmeQPl5Ng","cls2":"nqZKG3PoCWGRzYVCThCz _4ELBWVKbV_FcmeQPl5Ng"};